export const COMMON_ROUTES = {
  CONFIG: '/config',
  API_ERROR: '/apiError',
  ERROR: '/error',
  NOT_FOUND: '*',
} as const;
